import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as Constants from '../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  dispatchAllManufacturerDetails,
  dispatchContactType,
  dispatchCopyContactDropdown,
  dispatchExistingContactDetails,
  dispatchGetAllClientGroupPlanList,
  dispatchGetAllClientList,
  dispatchGetAllClientListData,
  dispatchGetAllContractList,
  dispatchGetAllExistingContactList,
  dispatchGetAllProviderList,
  dispatchUpdateContactDetail,
} from '../../Manufacturer/store/ManufacturerAction';

export const selectionList = () => {
  return {
    type: actionTypes.SELECTION_TYPE_OPTIONS,
    payload: [
      {
        name: Constants.MANUFACTURER_REBATE,
        value: Constants.MANUFACTURER_REBATE_ID,
      },
      {
        name: Constants.DRUG_FAMILY,
        value: Constants.CONTRACT_DRUG_FAMILTY_ID,
      },
      {
        name: Constants.MARKET_BASKET_CONTRACT,
        value: Constants.CONTRACT_MARKET_BASKET_ID,
      },
      { name: Constants.CONTRACT, value: Constants.SEARCH_CONTRACT_ID },
    ],
  };
};

export const selectedType = (val) => {
  return {
    type: actionTypes.SELECTED_TYPE,
    payload: val,
  };
};

export const addCoverageDate = (payload) => ({
  type: actionTypes.ADD_COVERAGE_DATE,
  payload,
});

export const selectCreatePlanType = (val) => {
  return {
    type: actionTypes.SELECTED_CREATE_PLAN_TYPE,
    payload: val,
  };
};

export const selectedSearchType = (val) => {
  return {
    type: actionTypes.SELECTED_SEARCH_TYPE,
    payload: val,
  };
};

export const searchContractActions = (data) => {
  return {
    type: actionTypes.SEARCH_CONTRACT_STATE,
    payload: data,
  };
};

export const errorSearchContractActions = (data) => {
  return {
    type: actionTypes.ERROR_SEARCH_CONTRACT,
    payload: data,
  };
};
export const errorOtherSearchContractActions = (data) => {
  return {
    type: actionTypes.ERROR_OTHER_SEARCH_CONTRACT,
    payload: data,
  };
};

export const dispatchPlanTypeFilterData = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  planType: data,
});

export const getAllPlanTypeValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanTypeFilterData(response.data));
    })
    .catch(() => {
      dispatch(dispatchPlanTypeFilterData([]));
    });
};

// ################ Rebate Program Code Dropdown ######################
export const dispatchAllRebateProgramCode = (data) => {
  return {
    type: actionTypes.GET_ALL_REBATE_PROGRAMS,
    payload: data,
  };
};
export const getRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => {
      return dispatch(dispatchAllRebateProgramCode(response.data));
    })
    .catch((response) => {
      dispatch(dispatchAllRebateProgramCode(response.date));
    });
};

export const dispatchPopupRebateProgramCode = (data) => ({
  type: actionTypes.GET_POPUP_REBATE_PROGRAMS,
  payload: data,
});

export const getPopupRebateProgramCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`, { planType: values })
    .then((response) => dispatch(dispatchPopupRebateProgramCode(response.data)))
    .catch((error) => dispatch(dispatchPopupRebateProgramCode([])));
};

export const dispatchTabValue = (data) => ({
  type: actionTypes.GET_CONTRACT_TAB_VALUE,
  payload: data,
});

export const dispatchReferences = (data) => ({
  type: actionTypes.GET_MARKET_BASKET_NAME,
  payload: data,
  //state: state,
});

export const getReferences = (value) => (dispatch) => {
  //if (state === 'basketname') {
  return axios
    .post(`${serviceEndPoint.GET_MARKET_BASKET_NAME}`, {})
    .then((response) => {
      return dispatch(dispatchReferences(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchReferences(error));
    });
};
// call API for dropdown list
export const getCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_DROPDOWN, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const dispatchCoverageGapTable = (data) => ({
  type: actionTypes.GET_COVERAGE_TABLE,
  payload: data,
});

export const dispatchCoverageTable = (
  data = {},
  index = '',
  colId = '',
  functionality = ''
) => {
  return (dispatch) => {
    // let dataArray = [
    //   ...getState().sharedState.ContractReducer.getCoverageTable,
    // ];
    const payload = {};
    payload.newField = data;
    payload.index = index;
    payload.colId = colId;
    payload.functionality = functionality;
    dispatch(dispatchCoverageGapTable(payload));
  };
};

export const maintainContractActions = (data) => {
  return {
    type: actionTypes.MAITAIN_CONTRACT_STATE,
    payload: data,
  };
};

export const dispatchDrugSpecialist = (data) => ({
  type: actionTypes.GET_DISPUTE_SPECIALIST,
  payload: data,
});

export const getDrugSpecialist = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_DISPUTE_SPECIALIST, {})
    .then((response) => {
      let finalResponse = [];
      if (
        response?.data?.message === 'Success' &&
        response?.data?.status === '001'
      ) {
        finalResponse = response?.data?.secUsers || [];
      }
      return dispatch(dispatchDrugSpecialist(finalResponse));
    })
    .catch(() => {
      return dispatch(dispatchDrugSpecialist([]));
    });
};


export const dispatchLetterSenderDetails = (data) => ({
  type: actionTypes.GET_LETTER_SENDER,
  payload: data,
});

export const getLetterSenderDetails = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_LETTER_SENDER}`, {})
    .then((response) => {
      return dispatch(dispatchLetterSenderDetails(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchLetterSenderDetails(error));
    });
};

export const dispatchContractContactType = (data) => ({
  type: actionTypes.GET_CONTRACT_CONTACT_TYPE,
  payload: data,
});

export const getContractContactType = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_CONTACT_TYPE}`, value)
    .then((response) => {
      return dispatch(dispatchContractContactType(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchContractContactType(error));
    });
};

// On click on Search contract
export const dispatchSearchContract = (data) => ({
  type: actionTypes.GET_CONTRACT_SEARCH_DATA,
  payload: data,
});

export const getSearchContractData = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_SEARCH_DATA}`, value)
    .then((response) => {
      return dispatch(
        dispatchSearchContract(response?.data?.contractSearchResponseList)
      );
    })
    .catch((error) => {
      dispatch(dispatchSearchContract(error));
    });
};

// Get all details for COntract
export const dispatchAllContractDetails = (data) => ({
  type: actionTypes.GET_ALL_CONTRACTS_DETAILS,
  payload: data,
});

export const dispatchCalcTabDetails = (data) =>({
  type: actionTypes.CONTRACT_TAB_DATA,
  payload:data
})

export const getAllContractDetails = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_CONTRACTS_DETAILS}`, value)
    .then((response) => {
    const calcTabData = {
        cmsNdcInclInd: response?.data?.contractDetailsData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.cmsNdcInclInd,
        nonCmsNdcInclInd: response?.data?.contractDetailsData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.nonCmsNdcInclInd,
        contractCalcMethodCd: response?.data?.contractDetailsData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.contractCalcMethodCd,
        calcNonInnovPct: response?.data?.contractDetailsData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.calcNonInnovPct,
        calcInnovSinglePct: response?.data?.contractDetailsData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab?.calcInnovSinglePct,
      }
      dispatch(
        dispatchCalcTabDetails(calcTabData)
      )
      return dispatch(
        dispatchAllContractDetails(response?.data?.contractDetailsData)
      );
    })
    .catch(() => {
      dispatch(dispatchAllContractDetails({ error: 'API failed' }));
    });
};

// Get Contract Quarter
export const dispatchContractQuarter = (data) => ({
  type: actionTypes.GET_QUARTER_FOR_CONTRACT,
  payload: data,
});

export const getContractQuarter = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_QUARTER_FOR_CONTRACT}`, {})
    .then((response) => {
      return dispatch(dispatchContractQuarter(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchContractQuarter(''));
    });
};

// Get Contract Sequence number for create contract
export const dispatchContractSequenceNum = (data) => ({
  type: actionTypes.GET_CONTRACT_SEQUENCE_NUM,
  payload: data,
});

export const getContractSequenceNum = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_SEQUENCE_NUM}`, {})
    .then((response) => {
      return dispatch(dispatchContractSequenceNum(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchContractSequenceNum(error));
    });
};

// Get All Contract form Copy contract
export const dispatchAllCopyContract = (data) => ({
  type: actionTypes.GET_CONTRACT_FROM_COPY_CONTRACT,
  payload: data,
});

export const getAllCopyContract = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_FROM_COPY_CONTRACT}`, value)
    .then((response) => {
      return dispatch(dispatchAllCopyContract(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchAllCopyContract(error));
    });
};
// Default manufacturer data
export const dispatchDefaultMfgData = (data) => ({
  type: actionTypes.GET_DEFAULT_MFG_DATA,
  defaultMfgDataDataForContract: data,
});

export const getDefaultMfgData = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_DEFAULT_MFG_DATA}`, value)
    .then((response) => {
      return dispatch(
        dispatchDefaultMfgData(response?.data?.defaultMfgDataDataForContract)
      );
    })
    .catch((error) => {
      dispatch(dispatchDefaultMfgData(error));
    });
};
// Default rebate program data
export const dispatchDefaultRpcData = (data) => ({
  type: actionTypes.GET_DEFAULT_RPC_DATA,
  payload: data,
});

export const getDefaultRpcData = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_DEFAULT_RPC_DATA}`, value)
    .then((response) => {
      return dispatch(
        dispatchDefaultRpcData(response?.data?.defaultRPCDataDataForContract)
      );
    })
    .catch((error) => {
      dispatch(dispatchDefaultRpcData(error));
    });
};

export const errorMaintainContractActions = (data) => {
  return {
    type: actionTypes.ERROR_MAINTAIN_CONTRACT,
    payload: data,
  };
};

// Get All MFG if based on plan and rebate program type
export const dispatchAllMfgIdUsingRebateProg = (data) => ({
  type: actionTypes.GET_MFG_BY_PLAN_REBATE_PROG,
  payload: data,
});

export const getAllMfgIdUsingRebateProg = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_MFG_BY_PLAN_REBATE_PROG}`, value)
    .then((response) => {
      return dispatch(
        dispatchAllMfgIdUsingRebateProg(response?.data?.mfgIdAndNameData)
      );
    })
    .catch((error) => {
      dispatch(dispatchAllMfgIdUsingRebateProg(error));
    });
};
// Get All DRUG family based on mfg id
export const dispatchAllDrugFamiliesUsingMfgId = (data) => ({
  type: actionTypes.GET_DRUG_FAMILY_BY_MFG_ID,
  payload: data,
});

export const getAllDrugFamiliesUsingMfgId = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_DRUG_FAMILY_BY_MFG_ID}`, value)
    .then((response) => {
      return dispatch(
        dispatchAllDrugFamiliesUsingMfgId(response?.data?.mfgDrugFamilyVOs)
      );
    })
    .catch((error) => {
      dispatch(dispatchAllDrugFamiliesUsingMfgId(error));
    });
};
export const dispatchDrugFamilyTable = (data) => ({
  type: actionTypes.GET_DRUG_FAMILY_TABLE,
  payload: data,
});

export const selectedRow = (data) => ({
  type: actionTypes.SELECTED_ROW,
  payload: data,
});
export const dispatchDrugTable = (
  data = {},
  index = '',
  colId = '',
  functionality = ''
) => {
  return (dispatch) => {
    // let dataArray = [
    //   ...getState().sharedState.ContractReducer.getDrugFamilyTable,
    // ];
    const payload = {};
    payload.newField = data;
    payload.index = index;
    payload.colId = colId;
    payload.functionality = functionality;
    dispatch(dispatchDrugFamilyTable(payload));
  };
};
// ################ Get PDF for Validate Contract ######################
export const dispatchValidateContract = (data) => {
  return {
    type: actionTypes.VALIDATE_CONTRACT,
    getValidatedContract: data,
  };
};
export const getValidateContract = (values) => (dispatch) => {
  const url = `${serviceEndPoint.VALIDATE_CONTRACT}`;
  const req = values;
  return axios
    .post(url, req, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
    .then((response) => {
      return dispatch(dispatchValidateContract(response.data));
    })
    .catch((response) => {
      dispatch(dispatchValidateContract(response.data));
    });
};
// Get Write off date for contract
export const dispatchWriteOffDate = (data) => ({
  type: actionTypes.GET_WRITE_OFF_DATE_CONTRACT,
  getWriteOffDate: data,
});

export const getWriteOffDateContract = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_WRITE_OFF_DATE_CONTRACT}`, value)
    .then((response) => {
      return dispatch(dispatchWriteOffDate(response?.data?.writeOffResponse));
    })
    .catch((error) => {
      dispatch(dispatchWriteOffDate(error));
    });
};

// Update and Save for contract
export const dispatchCreateAndUpdateContract = (data) => ({
  type: actionTypes.CREATE_UPDATE_CONTRACT,
  payload: data,
});

export const getCreateAndUpdateContract = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.CREATE_UPDATE_CONTRACT}`, value)
    .then((response) => {
      return dispatch(
        dispatchCreateAndUpdateContract(
          response?.data?.createSaveSuccessMessage
        )
      );
    })
    .catch(() => {
      dispatch(dispatchCreateAndUpdateContract('API Failed'));
    });
};
export const handleErrorMessages = (data) => ({
  type: actionTypes.HANDLE_ERROR_MESSAGE_FOR_CONTRACT,
  errorMessagesInRedux: data,
});

// Get Undo Write off date for contract
export const dispatchUndoWriteOffDate = (data) => ({
  type: actionTypes.GET_UNDO_WRITE_OFF_DATE_CONTRACT,
  getUndoWriteOffDate: data,
});

export const getUndoWriteOffDateContract = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_UNDO_WRITE_OFF_DATE_CONTRACT}`, value)
    .then((response) => {
      return dispatch(
        dispatchUndoWriteOffDate(response?.data?.writeOffResponse)
      );
    })
    .catch((error) => {
      dispatch(dispatchUndoWriteOffDate(error));
    });
};
export const clearReduxContract = () => {
  return {
    type: actionTypes.CLEAR_REDUX_CTRCT,
  };
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// Show contracts using this contacts
export const dispatchGetContractInfo = (data) => ({
  type: actionTypes.GET_CONTRACT_INFO,
  getShowContractInfo: data,
});

export const getContractInfo = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_INFO}`, value)
    .then((response) => {
      return dispatch(
        dispatchGetContractInfo(response?.data?.contractResponseVOs)
      );
    })
    .catch(() => {
      dispatch(dispatchGetContractInfo('API Failed'));
    });
};

export const dispatchInitialResponse = (val) => {
  return {
    type: actionTypes.INITIAL_RESPONSE,
    payload: val,
  };
};
export const dispatchCellClick = (val) => {
  return {
    type: actionTypes.CELL_CLICK,
    payload: val,
  };
};
// Get Contract Sequence number for create contract
export const dispatchNewContractSequenceNum = (data) => ({
  type: actionTypes.GET_NEW_CONTRACT_SEQUENCE_NUM,
  newContractSeqNum: data,
});

export const getNewContractSequenceNum = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_SEQUENCE_NUM}`, {})
    .then((response) => {
      return dispatch(dispatchNewContractSequenceNum(response?.data?.data));
    })
    .catch((error) => {
      dispatch(dispatchNewContractSequenceNum(error));
    });
};

// Get select contract for invoice contact list
export const dispatchSelectContractForInvoiceContact = (data) => ({
  type: actionTypes.GET_SELECT_CONTRACT_FOR_INVOICE_CONTACT,
  selectInvoiceContactList: data,
});

export const getInvChooseContactData = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_INV_CHOOSE_CONTACT}`, value)
    .then((response) => {
      return dispatch(
        dispatchSelectContractForInvoiceContact(
          response?.data?.chooseContactResponseVO
        )
      );
    })
    .catch(() => {
      dispatch(dispatchSelectContractForInvoiceContact([]));
    });
};
// Get select contract for dispute contact list
export const dispatchSelectContractForDisputeContact = (data) => ({
  type: actionTypes.GET_SELECT_CONTRACT_FOR_DISPUTE_CONTACT,
  selectDisputeContactList: data,
});

export const getDisputeChooseContactData = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_DISP_CHOOSE_CONTACT}`, value)
    .then((response) => {
      return dispatch(
        dispatchSelectContractForDisputeContact(
          response?.data?.chooseContactResponseVO
        )
      );
    })
    .catch(() => {
      dispatch(dispatchSelectContractForDisputeContact([]));
    });
};

// Get select contract contact
export const dispatchInvContactDetails = (data) => ({
  type: actionTypes.GET_INV_CONTRACT_CONTACT_DETAILS,
  payload: data,
});

export const getInvContactDetails = (value) => (dispatch) => {
  const req = { invContactSeqNum: value.invContactSeqNum };
  return axios
    .post(`${serviceEndPoint.GET_CONTRACT_CONTACT_DETAILS}`, req)
    .then((response) => {
      const res = response?.data?.contactData;
      res.type = value.type;
      return dispatch(dispatchInvContactDetails(res));
    })
    .catch(() => {
      dispatch(dispatchInvContactDetails('API Failed'));
    });
};

// Get select Dispute contact for contract
export const dispatchDisputeContactDetails = (data) => ({
  type: actionTypes.GET_DISPUTE_CONTRACT_CONTACT_DETAILS,
  payload: data,
});

export const getDisputeContactDetails = (value) => (dispatch) => {
  const req = { contactSeqNum: value.contactSeqNum };
  return axios
    .post(`${serviceEndPoint.GET_DISPUTE_CONTRACT_CONTACT_DETAILS}`, req)
    .then((response) => {
      const res = response?.data?.contactData;
      res.type = value.type;
      return dispatch(dispatchDisputeContactDetails(res));
    })
    .catch(() => {
      dispatch(dispatchDisputeContactDetails('API Failed'));
    });
};

export const dispatchDeleteDrugFamily = (data) => {
  return {
    type: actionTypes.GET_DELETE_DRUG_FAMILY_TABLE,
    payload: data,
  };
};

export const dispatchDeleteCoverageGap = (data) => {
  return {
    type: actionTypes.GET_DELETE_COVERAGE_GAP,
    payload: data,
  };
};

export const dispatchInitialCoverageGap = (data) => {
  return {
    type: actionTypes.GET_LOAD_COVERAGE_TABLE,
    payload: data,
  };
};

export const dispatchCommonContractDropdownData = (data) => {
  return {
    payload: data,
    type: actionTypes.GET_COMMON_CONTRACT_DROPDOWN,
  };
};

export const fetchAllCommonDrugFamilyContractDropdownList =
  (value) => (dispatch) => {
    return axios
      .post(serviceEndPoint.SYSTEM_LIST_DROPDOWN, value)
      .then((response) => {
        return dispatch(dispatchCommonContractDropdownData(response.data));
      })
      .catch(() => {
        dispatch(dispatchCommonContractDropdownData([]));
      });
  };
export const clearReduxMaintainContractSearchScreen = () => (dispatch) => {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = today.getMonth() + 1; // Months start at 0!
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const currDate = `${mm}/${dd}/${yyyy}`;

  dispatch(selectedType('MF'));
  dispatch(dispatchAllMfgIdUsingRebateProg([]));
  dispatch(dispatchAllDrugFamiliesUsingMfgId([]));
  dispatch(
    searchContractActions({
      planType: 'FD',
      //rebateProgramCode: '-1',
      createPlanType: 'ST',
      createRebateProgramCode: '-1',
      searchContractDate: currDate,
      selectedContractType: '',
      selectedRowData: '',
      selectedMfgName: '',
      contractType: '',
      getQuarter: '',
      errorInvalidQuarter: false,
      errorQuarterRequired: false,
      errorInvalidDate: false,
      errorDateRequired: false,
      errorRebateProg: false,
      selectedCreateMfgRowData: {},
    })
  );
  dispatch(errorSearchContractActions([]));
  dispatch(errorOtherSearchContractActions([]));
  dispatch(dispatchSearchContract([]));
  dispatch(dispatchPlanTypeFilterData([]));
};

export const clearReduxMaintainContractDetailScreen = () => (dispatch) => {
  dispatch(dispatchDrugFamilyTable([]));
  dispatch(dispatchSelectContractForInvoiceContact([]));
  dispatch(dispatchSelectContractForDisputeContact([]));
  dispatch(dispatchCreateAndUpdateContract(''));
  dispatch(dispatchInvContactDetails({}));
  dispatch(dispatchAllRebateProgramCode([]));
  dispatch(dispatchPopupRebateProgramCode([]));
  dispatch(dispatchDisputeContactDetails({}));
  dispatch(dispatchContactType([]));
  dispatch(dispatchUpdateContactDetail([]));
  dispatch(dispatchExistingContactDetails([]));
  dispatch(dispatchCopyContactDropdown([]));
  dispatch(dispatchGetAllClientList([]));
  dispatch(dispatchGetAllClientGroupPlanList([]));
  dispatch(dispatchGetAllClientListData([]));
  dispatch(dispatchGetAllContractList([]));
  dispatch(dispatchGetAllExistingContactList([]));
  dispatch(dispatchAllManufacturerDetails([]));
  dispatch(dispatchGetAllProviderList([]));
};
